import { render, staticRenderFns } from "./DisputeComments.vue?vue&type=template&id=ea12cb46&scoped=true"
import script from "./DisputeComments.vue?vue&type=script&lang=js"
export * from "./DisputeComments.vue?vue&type=script&lang=js"
import style0 from "./DisputeComments.vue?vue&type=style&index=0&id=ea12cb46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea12cb46",
  null
  
)

export default component.exports